<!--
 * @Author: wjc
 * @Date: 2025-09-11 11:06:29
 * @LastEditors: wjc
 * @LastEditTime: 2025-09-28 15:12:29
 * @Description: 
-->
<template>
  <TooltipArrow v-bind="props" :class="clsx('tooltip-arrow fill-popover stroke-popover')" />
</template>

<script setup lang="ts">
  import type { TooltipArrowProps } from 'reka-ui'

  import { clsx } from 'clsx'
  import { TooltipArrow } from 'reka-ui'

  const props = defineProps<TooltipArrowProps>()
</script>

<style lang="scss">
  .tooltip-arrow {
    inset-inline: 0;
    // box-shadow: 2px 2px 5px rgb(0 0 0 / 5%);
  }
</style>
